import { useState, useEffect } from 'react';
const ADS = [
  { text: <><strong style={{color:'#F0F6FF'}}>Panduit</strong> — Premium data center infrastructure. Trusted by Fortune 500.</>, cta:'Learn More' },
  { text: <><strong style={{color:'#F0F6FF'}}>CommScope</strong> — Enterprise cabling solutions engineered for scale.</>, cta:'Explore' },
  { text: <><strong style={{color:'#F0F6FF'}}>Legrand</strong> — Smart power distribution for modern data centers.</>, cta:'See Products' },
  { text: <><strong style={{color:'#F0F6FF'}}>Advertise on iTekPros</strong> — Reach verified DC professionals & enterprise customers.</>, cta:'Contact Us' },
];
const css = `.adbanner{display:flex;align-items:center;justify-content:space-between;padding:7px 24px;
  background:linear-gradient(90deg,#1A2B45,#0F1F38);border-bottom:1px solid rgba(245,166,35,0.15);
  font-size:12px;color:#8899AA;gap:12px;}
.ad-tag{font-size:9px;letter-spacing:1.5px;text-transform:uppercase;color:#6DBE45;font-weight:700;
  border:1px solid rgba(245,166,35,0.35);padding:2px 6px;border-radius:3px;flex-shrink:0;}
.ad-cta{font-size:11px;color:#AAB8C8;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.08);
  padding:4px 10px;border-radius:4px;cursor:pointer;flex-shrink:0;transition:all 0.2s;}
.ad-cta:hover{background:rgba(255,255,255,0.1);}
@media(max-width:640px){.adbanner{padding:6px 16px;}}`;
export default function AdBanner() {
  const [i, setI] = useState(0);
  useEffect(() => { const t = setInterval(() => setI(x=>(x+1)%ADS.length),6000); return()=>clearInterval(t); },[]);
  return (<><style>{css}</style>
    <div className="adbanner">
      <div style={{display:'flex',alignItems:'center',gap:8,overflow:'hidden'}}>
        <span className="ad-tag">Ad</span>
        <span style={{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{ADS[i].text}</span>
      </div>
      <button className="ad-cta">{ADS[i].cta} →</button>
    </div></>);
}
